/**
 * Lineup Grid.
 * 
 */

/**
 * Filter grid.
 * 
 */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

function initFilter() {
	console.log("initFilter()");

	let
		$filterBtns = $('.lineup-filters__link'),
		$chips = $('.lineup-grid__chip');

	$filterBtns.click(function() {
		let
			$myBtn = $(this),
			myFilter = $myBtn.data('filter'),
			$myChips = $('.lineup-grid__chip.'+myFilter),
			// $notMyChips = $('.lineup-grid__chip:not(:has(.'+myFilter+'))');
			$notMyChips = $('.lineup-grid__chip').not('.'+myFilter);

		if ($myBtn.hasClass('is-active')) {
			$myBtn.removeClass('is-active');
			$notMyChips.show();
		} else {
			$filterBtns.removeClass('is-active');
			$(this).addClass('is-active');
			$myChips.show();
			$notMyChips.hide();
		}
	});
}

function runFilter() {
	console.log("runFilter()");

	let	
		$filterBtn = $('.lineup-filters__link.is-active'),
		myFilter = $filterBtn.data('filter'),
		$myChips = $('.lineup-grid__chip.'+myFilter),
		$notMyChips = $('.lineup-grid__chip').not('.'+myFilter);

	if ($myChips.length > 0) {
		$myChips.show();
		$notMyChips.hide();
	}
}


exports.init = function () {
    // Run init methods...
    runFilter();
    initFilter();
};